import React, { useEffect, useState } from 'react';
import { Row, Col, Badge, Button, Form, Accordion } from 'react-bootstrap';
import { ChevronDown, ChevronUp, X } from 'react-feather';
import { DecryptFE } from '../lib/encrypt';
import { formatDate } from '@fullcalendar/core/index.js';
import { Icon } from '@iconify/react/dist/iconify.js';
import { TrainingRightsSection } from './child/TrainingRightsSection';

const customStyles = `
  /* Remove default bootstrap arrow */
.accordion-button::after {
  display: none !important;
}
* {
  box-sizing: border-box;
}
.personal-fields {
    border-bottom: 1px solid #E8F5E8 !important;
    padding-bottom: 12px !important;
    margin-bottom: 12px !important;
}
.personal-fields:last-child {
    border-bottom: none !important;
}
.land-details-text {
    font-size: 14px;
    font-weight: 500;
    color: black;
}
.land-details-value {
    font-size: 16px;
    font-weight: 700;
    color: #126B3A;
    text-align: center;
}
.crop-variant-accordion {
    border: 1px solid #C8E6C9;
    border-radius: 8px;
    margin-bottom: 12px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(27, 94, 32, 0.05);
    transition: box-shadow 0.2s ease;
}
.crop-variant-accordion:hover {
    box-shadow: 0 4px 8px rgba(27, 94, 32, 0.1);
}
.crop-variant-header {
    background-color: #F1F8E9 !important;
    border: none !important;
    border-bottom: 1px solid #C8E6C9 !important;
}
.crop-variant-body {
    background-color: #F9FDF9 !important;
}
.variant-phase-item {
    border-left: 3px solid #1B5E20;
    margin: 10px 0;
    padding: 12px;
    background-color: #F1F8E9;
    border-radius: 4px;
}
.phase-status-active {
    color: #1B5E20;
    font-weight: 600;
    background-color: #E8F5E8;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    display: inline-block;
}
.phase-status-upcoming {
    color: #F59E0B;
    font-weight: 600;
    background-color: #FEF3C7;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    display: inline-block;
}
.phase-status-completed {
    color: #6B7280;
    font-weight: 600;
    background-color: #F3F4F6;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    display: inline-block;
}
.crop-variant-header-custom button {
    background-color: white !important;
    box-shadow: none !important;
    padding: 0 !important;
}

.crop-variant-header-custom button::after {
    margin-right: 15px;
}

.crop-variant-header-custom button:not(.collapsed) {
    color: inherit;
}
.family-info-card {
    border: 1px solid #C8E6C9;
    border-radius: 10px;
    padding: 16px;
    margin-bottom: 14px;
    background-color: #F9FDF9;
    box-shadow: 0 2px 4px rgba(27, 94, 32, 0.04);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.family-info-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(27, 94, 32, 0.08);
}
.family-member-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    border-bottom: none;
}
.family-member-row:last-child {
    border-bottom: none;
}
.age-group-badge {
    display: inline-block;
    background-color: #E8F5E8;
    color: #1B5E20;
    padding: 5px 12px;
    border-radius: 14px;
    font-size: 12px;
    font-weight: 600;
}
`;


const FilterUserDrawer = ({ selectedUser, onClose }) => {
    const [activeTab, setActiveTab] = useState('personal');
    const [showTrainingRights, setShowTrainingRights] = useState(false);
    const [expandedCrops, setExpandedCrops] = useState({});

    useEffect(() => {
        if (selectedUser) {
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [selectedUser]);

    if (!selectedUser) return null;


    const decryptedUser = {
        ...selectedUser,
        GivenName: DecryptFE(selectedUser.GivenName || ''),
        FamilyName: DecryptFE(selectedUser.FamilyName || ''),
        MobileNumber: DecryptFE(selectedUser.MobileNumber || ''),
        Gender: DecryptFE(selectedUser.Gender || ''),
        NationalID: DecryptFE(selectedUser.NationalID || ''),
    };

    const DetailItem = ({ label, value }) => (
        <div className="mb-3">
            <div className="d-flex justify-content-between">
                <span style={{ color: '#666', fontSize: '14px' }}>{label}</span>
                <span style={{ color: '#1B5E20', fontWeight: '500', fontSize: '14px' }}>{value || 'N/A'}</span>
            </div>
        </div>
    );

    const Section = ({ title, children }) => (
        <div className="mb-4">
            <h6 style={{ color: '#1B5E20', fontWeight: '600', marginBottom: '15px', fontSize: '14px' }}>
                {title}
            </h6>
            {children}
        </div>
    );
    const groupVariantsByCrop = () => {
        const grouped = {};

        if (selectedUser.FarmersCropPhasePeriodDateDetail && Array.isArray(selectedUser.FarmersCropPhasePeriodDateDetail)) {
            selectedUser.FarmersCropPhasePeriodDateDetail.forEach(phase => {
                const cropId = phase.CropID;
                const variantId = phase.VariantID;

                if (!grouped[cropId]) {
                    grouped[cropId] = {
                        cropId: cropId,
                        cropName: phase.CropName || getCropNameById(cropId),
                        cropImage: getCropImage(cropId),
                        sowingDate: getSowingDate(cropId),
                        variants: {}
                    };
                }

                if (!grouped[cropId].variants[variantId]) {
                    grouped[cropId].variants[variantId] = {
                        variantId: variantId,
                        variantName: phase.VariantName || 'Unknown Variant',
                        featureImage: phase.FeatureImage || 'default-crop.jpg',
                        phases: []
                    };
                }

                grouped[cropId].variants[variantId].phases.push(phase);
            });

            // Sort phases by start date for each variant
            Object.keys(grouped).forEach(cropId => {
                Object.keys(grouped[cropId].variants).forEach(variantId => {
                    grouped[cropId].variants[variantId].phases.sort((a, b) =>
                        new Date(a.PhaseStartDate) - new Date(b.PhaseStartDate)
                    );
                });
            });
        }

        return grouped;
    };

    // Get crop name by ID
    const getCropNameById = (cropId) => {
        if (selectedUser.FarmersFarmingInterests && Array.isArray(selectedUser.FarmersFarmingInterests)) {
            const crop = selectedUser.FarmersFarmingInterests.find(item => item.CropID === cropId);
            return crop ? crop.Crop : 'Unknown Crop';
        }
        return 'Unknown Crop';
    };

    // Get crop image
    const getCropImage = (cropId) => {
        if (selectedUser.FarmersFarmingInterests && Array.isArray(selectedUser.FarmersFarmingInterests)) {
            const crop = selectedUser.FarmersFarmingInterests.find(item => item.CropID === cropId);
            return crop?.SystemFileName || 'default-crop.png';
        }
        return 'default-crop.png';
    };

    // Get sowing date for crop
    const getSowingDate = (cropId) => {
        if (selectedUser.FarmersFarmingInterests && Array.isArray(selectedUser.FarmersFarmingInterests)) {
            const crop = selectedUser.FarmersFarmingInterests.find(item => item.CropID === cropId);
            return crop?.DateOfSowing || null;
        }
        return null;
    };

    // Get current phase for a variant
    const getCurrentPhase = (phases) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        for (const phase of phases) {
            const startDate = new Date(phase.PhaseStartDate);
            const endDate = new Date(phase.PhaseEndDate);

            startDate.setHours(0, 0, 0, 0);
            endDate.setHours(0, 0, 0, 0);

            if (today >= startDate && today <= endDate) {
                return phase;
            }
        }

        // If no active phase, find next upcoming phase
        const upcomingPhases = phases.filter(phase => {
            const startDate = new Date(phase.PhaseStartDate);
            startDate.setHours(0, 0, 0, 0);
            return today < startDate;
        });

        return upcomingPhases.length > 0 ? upcomingPhases[0] : null;
    };

    // Get next phase after current
    const getNextPhase = (phases, currentPhase) => {
        if (!currentPhase || !phases.length) return null;

        const currentIndex = phases.findIndex(phase => phase.ID === currentPhase.ID);
        return phases[currentIndex + 1] || null;
    };

    const groupedVariants = groupVariantsByCrop();
    return (
        <>
            <style>{customStyles}</style>
            <div className="user-drawer" style={{
                position: 'fixed',
                right: 0,
                top: 0,
                height: '100vh',
                width: '650px',
                backgroundColor: 'white',
                boxShadow: '-5px 0 20px rgba(0,0,0,0.12)',
                zIndex: 1050,
                overflowY: 'hidden',
                overflowX: 'hidden',
                display: 'flex',
                flexDirection: 'column'
            }}>
                {showTrainingRights ? (
                    <TrainingRightsSection selectedUser={selectedUser} setShowTrainingRights={setShowTrainingRights} />
                ) : (
                    <div style={{
                        backgroundColor: '#F8FDF8',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%'
                    }} >
                        <Button
                            variant="outline"
                            onClick={onClose}
                            style={{
                                border: 'none',
                                color: '#000',
                                padding: '12px 16px',
                                textAlign: 'end',
                                width: '100%',
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                zIndex: 10,
                                backgroundColor: 'transparent'
                            }}
                        >
                            <X size={24} />
                        </Button>
                        <div style={{
                            padding: '20px 28px 16px 28px',
                            backgroundColor: '#F8FDF8',
                            paddingTop: '50px',
                            flexShrink: 0
                        }}>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="d-flex align-items-center">
                                    <div style={{
                                        width: '80px',
                                        height: '80px',
                                        borderRadius: '50%',
                                        marginRight: '15px',
                                        backgroundColor: '#F1F8E9',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden',
                                        border: '2px solid #E8F5E8'
                                    }}>
                                        {selectedUser.Photo ? (
                                            <img
                                                src={`https://api.soksan-dss.com/uploads/${selectedUser.Photo}`}
                                                alt="User"
                                                className="object-fit-cover w-100 h-100"
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.parentElement.innerHTML = `<span class="iconify" data-icon="solar:user-circle-bold" style="font-size: 80px; color: #1B5E20;"></span>`;
                                                }}
                                            />
                                        ) : (
                                            <Icon
                                                icon="solar:user-circle-bold"
                                                style={{ fontSize: '80px', color: '#1B5E20' }}
                                            />
                                        )}
                                    </div>

                                    <div>
                                        <div style={{
                                            color: '#000000ff',
                                            fontWeight: '600',
                                            margin: 0,
                                            fontSize: '20px'
                                        }}>
                                            {`${decryptedUser.GivenName} ${decryptedUser.FamilyName}`}
                                        </div>

                                        <div className="d-flex align-items-center mt-2">
                                            <Badge
                                                bg="light"
                                                text="dark"
                                                className="me-2 d-flex align-items-center"
                                                style={{ fontSize: '12px', padding: '4px 8px' }}
                                            >
                                                <span role="img" aria-label="Cambodia flag" className="me-1">
                                                    {selectedUser.Country === 'Cambodia' ? '🇰🇭' : '🌐'}
                                                </span>
                                                {selectedUser.Country || 'N/A'}
                                            </Badge>

                                            <Badge
                                                bg="light"
                                                text="dark"
                                                className="d-flex align-items-center"
                                                style={{ fontSize: '12px', padding: '4px 8px' }}
                                            >
                                                <span role="img" aria-label="Language icon" className="me-1">💬</span>
                                                {selectedUser.LanguageForComm || 'en'}
                                            </Badge>
                                        </div>

                                        <Button
                                            variant="success"
                                            style={{
                                                backgroundColor: '#126B3A',
                                                borderColor: '#126B3A',
                                                fontWeight: '500',
                                                padding: '5px 18px',
                                                fontSize: '14px',
                                                marginTop: '8px'
                                            }}
                                            onClick={() => setShowTrainingRights(!showTrainingRights)}
                                        >
                                            Give Training Rights
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            flex: 1,
                            width: '100%',
                            paddingRight: '4px'
                        }}>
                            <div>
                                <div>
                                    <div className="d-flex" style={{ borderBottom: '4px solid #F0F0F0' }}>
                                        <Button
                                            variant="link"
                                            className="text-decoration-none px-50"
                                            onClick={() => setActiveTab('personal')}
                                            style={{
                                                fontSize: '14px',
                                                color: activeTab === 'personal' ? '#1B5E20' : '#666',
                                                fontWeight: activeTab === 'personal' ? '600' : 'normal',
                                                backgroundColor: activeTab === 'personal' ? '#F1F8E9' : 'transparent',
                                                borderRadius: '4px 4px 0 0',
                                                border: 'none',
                                                borderBottom: activeTab === 'personal' ? '4px solid #1B5E20' : '4px solid transparent',
                                                marginRight: '10px',
                                                transition: 'all 0.1s ease-in-out',
                                                lineHeight: '1.2'
                                            }}
                                        >
                                            Personal Detail
                                        </Button>

                                        <Button
                                            variant="link"
                                            className="text-decoration-none px-50"
                                            onClick={() => setActiveTab('land')}
                                            style={{
                                                fontSize: '14px',
                                                color: activeTab === 'land' ? '#1B5E20' : '#666',
                                                fontWeight: activeTab === 'land' ? '600' : 'normal',
                                                backgroundColor: activeTab === 'land' ? '#F1F8E9' : 'transparent',
                                                borderRadius: '4px 4px 0 0',
                                                border: 'none',
                                                borderBottom: activeTab === 'land' ? '4px solid #1B5E20' : '4px solid transparent',
                                                marginRight: '10px',
                                                transition: 'all 0.1s ease-in-out',
                                                lineHeight: '1.2'
                                            }}
                                        >
                                            Land Detail
                                        </Button>

                                        <Button
                                            variant="link"
                                            className="text-decoration-none px-50"
                                            onClick={() => setActiveTab('crop')}
                                            style={{
                                                fontSize: '14px',
                                                color: activeTab === 'crop' ? '#1B5E20' : '#666',
                                                fontWeight: activeTab === 'crop' ? '600' : 'normal',
                                                backgroundColor: activeTab === 'crop' ? '#F1F8E9' : 'transparent',
                                                borderRadius: '4px 4px 0 0',
                                                border: 'none',
                                                borderBottom: activeTab === 'crop' ? '4px solid #1B5E20' : '4px solid transparent',
                                                transition: 'all 0.1s ease-in-out',
                                                lineHeight: '1.2'
                                            }}
                                        >
                                            Crop Detail
                                        </Button>

                                        <Button
                                            variant="link"
                                            className="text-decoration-none px-50"
                                            onClick={() => setActiveTab('family')}
                                            style={{
                                                fontSize: '14px',
                                                color: activeTab === 'family' ? '#1B5E20' : '#666',
                                                fontWeight: activeTab === 'family' ? '600' : 'normal',
                                                backgroundColor: activeTab === 'family' ? '#F1F8E9' : 'transparent',
                                                borderRadius: '4px 4px 0 0',
                                                border: 'none',
                                                borderBottom: activeTab === 'family' ? '4px solid #1B5E20' : '4px solid transparent',
                                                transition: 'all 0.1s ease-in-out',
                                                lineHeight: '1.2'
                                            }}
                                        >
                                            Family Info
                                        </Button>
                                    </div>
                                </div>
                                <div style={{ padding: '16px 28px 24px 28px', overflow: 'hidden' }}>
                                    {activeTab === 'personal' && (
                                        <div style={{ padding: '0' }}>
                                            <div className="mb-4">
                                                <Col>
                                                    <div className="personal-fields">
                                                        <DetailItem
                                                            label="Phone Number"
                                                            value={decryptedUser.MobileNumber}
                                                        />
                                                    </div>
                                                    <div className="personal-fields">
                                                        <DetailItem
                                                            label="Date Of Birth"
                                                            value={selectedUser.DOB || formatDate(selectedUser.DOB)}
                                                        />
                                                    </div>
                                                    <div className="personal-fields">
                                                        <DetailItem
                                                            label="Age"
                                                            value={selectedUser.Age ? `${selectedUser.Age} Years` : 'N/A'}
                                                        />
                                                    </div>
                                                    <div className="personal-fields">
                                                        <DetailItem
                                                            label="National ID Number"
                                                            value={decryptedUser.NationalID}
                                                        />
                                                    </div>
                                                    <div className="personal-fields">
                                                        <DetailItem
                                                            label="Gender"
                                                            value={decryptedUser.Gender}
                                                        />
                                                    </div>
                                                    <div className="personal-fields">
                                                        <DetailItem
                                                            label="Date Of Registration"
                                                            value={formatDate(selectedUser.CreatedOn)}
                                                        />
                                                    </div>
                                                    <div className="personal-fields">
                                                        <DetailItem
                                                            label="State"
                                                            value={selectedUser.ProvinceOrState}
                                                        />
                                                    </div>
                                                    <div className="personal-fields">
                                                        <DetailItem
                                                            label="District"
                                                            value={selectedUser.District}
                                                        />
                                                    </div>
                                                    <div className="personal-fields">
                                                        <DetailItem
                                                            label="Commune"
                                                            value={selectedUser.Commune}
                                                        />
                                                    </div>
                                                    <div className="personal-fields">
                                                        <DetailItem
                                                            label="Village"
                                                            value={selectedUser.Village}
                                                        />
                                                    </div>
                                                </Col>
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'land' && (
                                        <div style={{ padding: '0' }}>
                                            <div>
                                                <Row className="mb-4">
                                                    <Col md={6} className="mb-3 mb-md-0">
                                                        <div style={{
                                                            padding: '15px',
                                                            borderRadius: '5px',
                                                            border: '1px solid #C8E6C9',
                                                            boxShadow: '0 0 10px rgba(0, 0, 0, 0.05)'
                                                        }}>
                                                            <Section title={
                                                                <div className="d-flex align-items-center justify-content-center land-details-text" >
                                                                    <span style={{ color: '#1B5E20', marginRight: '5px' }}>🌿</span>
                                                                    Land Size
                                                                </div>
                                                            }>
                                                                <div style={{ borderBottom: '1px dashed #ccc', margin: '10px 0' }}></div>
                                                                <div className='land-details-value'>
                                                                    {selectedUser.LandSize || 'N/A'}
                                                                </div>
                                                            </Section>
                                                        </div>
                                                    </Col>

                                                    <Col md={6} className="mb-3 mb-md-0">
                                                        <div style={{
                                                            padding: '15px',
                                                            borderRadius: '5px',
                                                            border: '1px solid #C8E6C9',
                                                            boxShadow: '0 0 10px rgba(0, 0, 0, 0.05)'
                                                        }}>
                                                            <Section title={
                                                                <div className="d-flex align-items-center justify-content-center land-details-text ">
                                                                    <span style={{ color: '#1B5E20', marginRight: '5px' }}>🏠</span>
                                                                    Land Holding Type
                                                                </div>
                                                            }>
                                                                <div style={{ borderBottom: '1px dashed #ccc', margin: '10px 0' }}></div>
                                                                <div className='land-details-value'>
                                                                    {selectedUser.LandholdingType || 'N/A'}
                                                                </div>
                                                            </Section>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col md={6}>
                                                        <div style={{
                                                            padding: '15px',
                                                            borderRadius: '5px',
                                                            border: '1px solid #C8E6C9',
                                                            boxShadow: '0 0 10px rgba(0, 0, 0, 0.05)'
                                                        }}>
                                                            <Section title={
                                                                <div className="d-flex align-items-center justify-content-center land-details-text">
                                                                    <span style={{ color: '#1B5E20', marginRight: '5px' }}>📏</span>
                                                                    Land Unit
                                                                </div>
                                                            }>
                                                                <div style={{ borderBottom: '1px dashed #ccc', margin: '10px 0' }}></div>
                                                                <div className='land-details-value'>
                                                                    {selectedUser.UnitForLandSize || 'N/A'}
                                                                </div>
                                                            </Section>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'crop' && (
                                        <div className="p-3">
                                            {selectedUser.FarmersFarmingInterests && selectedUser.FarmersFarmingInterests.length > 0 && selectedUser.FarmersCropPhasePeriodDateDetail.length > 0 ? (
                                                Object.keys(groupedVariants).map((cropId) => {
                                                    const crop = groupedVariants[cropId];
                                                    const isExpanded = expandedCrops[cropId];
                                                    const variants = Object.values(crop.variants);

                                                    return (
                                                        <div key={cropId} className="mb-4">
                                                            <Accordion
                                                                activeKey={Object.keys(expandedCrops).filter(key => expandedCrops[key])}
                                                                onSelect={(eventKey) => {
                                                                    setExpandedCrops(prev => ({
                                                                        ...prev,
                                                                        [eventKey]: !prev[eventKey]
                                                                    }));
                                                                }}
                                                            >
                                                                <Accordion.Item eventKey={cropId} style={{ border: '1px solid #C8E6C9', borderRadius: '12px', overflow: 'hidden' }}>
                                                                    <Accordion.Header className="crop-variant-header-custom p-0">
                                                                        <div className="d-flex align-items-center justify-content-between w-100 p-2">
                                                                            <div className="d-flex align-items-center">
                                                                                <div style={{
                                                                                    width: '50px', height: '50px', borderRadius: '50%',
                                                                                    backgroundColor: '#F1F8E9', display: 'flex',
                                                                                    alignItems: 'center', justifyContent: 'center',
                                                                                    overflow: 'hidden', marginRight: '15px', border: '1px solid #C8E6C9'
                                                                                }}>
                                                                                    <img
                                                                                        src={`https://api.soksan-dss.com/uploads/crop/${crop.cropImage}`}
                                                                                        alt={crop.cropName}
                                                                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                                        onError={(e) => { e.target.src = 'assets/images/crop-image.png' }}
                                                                                    />
                                                                                </div>
                                                                                <div>
                                                                                    <div style={{ fontSize: '18px', fontWeight: '600', color: '#126B3A' }}>{crop.cropName}</div>
                                                                                    <Badge bg="success" style={{ backgroundColor: '#126B3A', fontWeight: '500' }}>
                                                                                        {variants.length} variant{variants.length !== 1 ? 's' : ''}
                                                                                    </Badge>
                                                                                </div>
                                                                            </div>

                                                                            {/* Accordion Toggle Icon */}
                                                                            <div className="d-flex align-items-center me-2">
                                                                                <Icon
                                                                                    icon={isExpanded ? "ep:arrow-up" : "ep:arrow-down"}
                                                                                    style={{
                                                                                        fontSize: '20px',
                                                                                        color: '#126B3A',
                                                                                        transition: 'transform 0.3s ease'
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </Accordion.Header>

                                                                    <Accordion.Body style={{ backgroundColor: '#fff', paddingBottom: '5px' }}>
                                                                        {variants.map((variant) => {
                                                                            const variantCurrentPhase = getCurrentPhase(variant.phases);
                                                                            const nextPhase = getNextPhase(variant.phases, variantCurrentPhase);

                                                                            return (
                                                                                <div key={variant.variantId}
                                                                                    className="d-flex align-items-stretch mb-3"
                                                                                    style={{
                                                                                        border: '1px solid #C8E6C9',
                                                                                        borderRadius: '12px',
                                                                                        overflow: 'hidden',
                                                                                        minHeight: '120px'
                                                                                    }}>
                                                                                    {/* Left Side: Image and Name */}
                                                                                    <div className="text-center d-flex flex-column align-items-center justify-content-center"
                                                                                        style={{ backgroundColor: '#E8F5E8', padding: '10px', minWidth: '90px' }}>
                                                                                        <div style={{ width: '60px', height: '60px', borderRadius: '12px', overflow: 'hidden', marginBottom: '8px', border: '2px solid #fff' }}>
                                                                                            <img
                                                                                                src={`https://api.soksan-dss.com/uploads/crop/VariantFeatureImages/${variant.featureImage}`}
                                                                                                alt={variant.variantName}
                                                                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                                                onError={(e) => { e.target.src = 'assets/images/crop-image.png' }}
                                                                                            />
                                                                                        </div>
                                                                                        <div style={{ fontWeight: '700', color: '#1B5E20', fontSize: '15px' }}>{crop.cropName}</div>
                                                                                        <div style={{ fontWeight: '600', color: '#126B3A', fontSize: '13px' }}>{variant.variantName}</div>
                                                                                    </div>

                                                                                    {/* Middle Divider Line */}
                                                                                    <div style={{ width: '1px', backgroundColor: '#C8E6C9', margin: '10px 0' }}></div>

                                                                                    {/* Right Side: Details Stacked Vertically - Improved Alignment */}
                                                                                    <div className="flex-grow-1 p-3 d-flex flex-column justify-content-center">
                                                                                        {/* Sowing Date */}
                                                                                        <div className="d-flex align-items-center mb-3">
                                                                                            <div style={{
                                                                                                minWidth: '30px',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'center'
                                                                                            }}>
                                                                                                <Icon icon="fluent-color:calendar-16" style={{ fontSize: '16px', color: '#1B5E20' }} />
                                                                                            </div>
                                                                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                                                                <div style={{ color: '#666', fontSize: '12px' }}>Sowing Date</div>
                                                                                                <div style={{ fontWeight: '600', fontSize: '12px', color: '#1B5E20', marginLeft: '10px' }}>
                                                                                                    {crop.sowingDate ? formatDate(crop.sowingDate) : 'N/A'}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* Current Stage */}
                                                                                        <div className="d-flex align-items-center mb-3">
                                                                                            <div style={{
                                                                                                minWidth: '30px',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'center'
                                                                                            }}>
                                                                                                <img
                                                                                                    src="assets/images/current-stage.png"
                                                                                                    alt="Current Stage"
                                                                                                    style={{ width: '16px', height: '16px', objectFit: 'contain' }}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                                                                <div style={{ color: '#666', fontSize: '12px' }}>Current Stage</div>
                                                                                                <div style={{ fontWeight: '600', fontSize: '12px', color: '#1B5E20', marginLeft: '10px' }}>
                                                                                                    {variantCurrentPhase ? variantCurrentPhase.PhaseName : 'N/A'}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* Next Stage */}
                                                                                        <div className="d-flex align-items-center mb-3">
                                                                                            <div style={{
                                                                                                minWidth: '30px',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'center'
                                                                                            }}>
                                                                                                <img
                                                                                                    src="assets/images/next-stage.png"
                                                                                                    alt="Next Stage"
                                                                                                    style={{ width: '16px', height: '16px', objectFit: 'contain' }}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                                                                <div style={{ color: '#666', fontSize: '12px' }}>Next Stage</div>
                                                                                                <div style={{ fontWeight: '600', fontSize: '12px', color: '#1B5E20', marginLeft: '10px' }}>
                                                                                                    {nextPhase ? nextPhase.PhaseName : 'N/A'}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* Next Stage Date */}
                                                                                        <div className="d-flex align-items-center">
                                                                                            <div style={{
                                                                                                minWidth: '30px',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'center'
                                                                                            }}>
                                                                                                <Icon icon="fluent-color:calendar-clock-16" style={{ fontSize: '16px', color: '#1B5E20' }} />
                                                                                            </div>
                                                                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                                                                <div style={{ color: '#666', fontSize: '12px' }}>Next Stage Date</div>
                                                                                                <div style={{ fontWeight: '600', fontSize: '12px', color: '#1B5E20', marginLeft: '10px' }}>
                                                                                                    {nextPhase ? formatDate(nextPhase.PhaseEndDate) : 'N/A'}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            </Accordion>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div className="empty-state text-center py-5">
                                                    <span style={{ fontSize: '48px' }}>🌱</span>
                                                    <div style={{ color: '#6B7280', fontSize: '14px', marginTop: '10px' }}>No crop data available</div>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {activeTab === 'family' && (
                                        <div style={{ padding: '0' }}>
                                            {selectedUser?.FarmersFamilyInfo && selectedUser.FarmersFamilyInfo.length > 0 ? (
                                                <div>
                                                    <div style={{ marginBottom: '20px' }}>
                                                        <div style={{
                                                            fontSize: '16px',
                                                            fontWeight: '600',
                                                            color: '#1B5E20',
                                                            marginBottom: '15px',
                                                            paddingBottom: '10px',
                                                            borderBottom: '2px solid #E8F5E8'
                                                        }}>
                                                            Family Members ({selectedUser.FarmersFamilyInfo.length})
                                                        </div>

                                                        {selectedUser.FarmersFamilyInfo.map((member, index) => (
                                                            <div key={member.ID || index} className='family-info-card'>
                                                                <div className="family-member-row">
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                        <div style={{
                                                                            width: '40px',
                                                                            height: '40px',
                                                                            borderRadius: '50%',
                                                                            backgroundColor: member.Gender === 'Male' ? '#E3F2FD' : '#FCE4EC',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            fontSize: '20px'
                                                                        }}>
                                                                            {member.Gender === 'Male' ? '👨' : '👩'}
                                                                        </div>
                                                                        <div>
                                                                            <div style={{
                                                                                fontWeight: '600',
                                                                                color: '#1B5E20',
                                                                                fontSize: '14px',
                                                                                marginBottom: '4px'
                                                                            }}>
                                                                                {member.AgeGroup?.AgeGroupName || 'N/A'}
                                                                            </div>
                                                                            <div style={{
                                                                                fontSize: '12px',
                                                                                color: '#666'
                                                                            }}>
                                                                                {member.Gender}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style={{
                                                                        textAlign: 'right'
                                                                    }}>
                                                                        <div style={{
                                                                            fontWeight: '600',
                                                                            color: '#1B5E20',
                                                                            fontSize: '16px',
                                                                            marginBottom: '4px'
                                                                        }}>
                                                                            {member.MemberCount}
                                                                        </div>
                                                                        <div style={{
                                                                            fontSize: '11px',
                                                                            color: '#999'
                                                                        }}>
                                                                            Member{member.MemberCount !== '1' ? 's' : ''}
                                                                        </div>
                                                                    </div>

                                                                    {/* Age Group Details */}
                                                                    {member.AgeGroup && (
                                                                        <div style={{
                                                                            marginTop: '12px',
                                                                            paddingTop: '12px',
                                                                            borderTop: '1px dashed #C8E6C9',
                                                                            display: 'grid',
                                                                            gridTemplateColumns: '1fr 1fr',
                                                                            gap: '10px'
                                                                        }}>
                                                                            <div>
                                                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '2px' }}>Min Age</div>
                                                                                <div style={{ fontWeight: '600', color: '#1B5E20', fontSize: '12px' }}>
                                                                                    {member.AgeGroup.MinAge} years
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <div style={{ fontSize: '11px', color: '#999', marginBottom: '2px' }}>Max Age</div>
                                                                                <div style={{ fontWeight: '600', color: '#1B5E20', fontSize: '12px' }}>
                                                                                    {member.AgeGroup.MaxAge} years
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="empty-state text-center py-5">
                                                    <span style={{ fontSize: '48px' }}>👨‍👩‍👧‍👦</span>
                                                    <div style={{ color: '#6B7280', fontSize: '14px', marginTop: '10px' }}>No family information available</div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default FilterUserDrawer;